import {
  // A
  IconAccessible,
  IconActivity,
  IconAdjustments,
  IconAdjustmentsHorizontal,
  IconAlertCircle,
  IconAlertTriangle,
  IconAlignCenter,
  IconAlignJustified,
  IconAlignLeft,
  IconAlignRight,
  IconAnchor,
  IconApps,
  IconArchive,
  IconArrowBack,
  IconArrowBackUp,
  IconArrowDown,
  IconArrowForward,
  IconArrowForwardUp,
  IconArrowLeft,
  IconArrowRight,
  IconArrowUp,
  IconArrowsMaximize,
  IconArrowsMinimize,
  IconArrowsMove,
  IconArrowsSort,
  IconAt,
  IconAtom,
  // B
  IconBan,
  IconBell,
  IconBellOff,
  IconBold,
  IconBook,
  IconBookmark,
  IconBookmarkOff,
  IconBox,
  IconBrandFacebook,
  IconBrandGithub,
  IconBrandGoogle,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandSlack,
  IconBrandTwitter,
  IconBrandYoutube,
  IconBriefcase,
  IconBrush,
  IconBug,
  IconBuilding,
  IconBuildingChurch,
  IconBulb,
  // C
  IconCalculator,
  IconCalendar,
  IconCalendarEvent,
  IconCalendarOff,
  IconCamera,
  IconCameraOff,
  IconCar,
  IconCards,
  IconCaretDown,
  IconCaretLeft,
  IconCaretRight,
  IconCaretUp,
  IconCash,
  IconCategory,
  IconChartArea,
  IconChartBar,
  IconChartDots,
  IconChartLine,
  IconChartPie,
  IconCheck,
  IconCheckbox,
  IconChecklist,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconChevronsDown,
  IconChevronsLeft,
  IconChevronsRight,
  IconChevronsUp,
  IconCircle,
  IconCircleCheck,
  IconCircleDashed,
  IconCircleDot,
  IconCircleMinus,
  IconCirclePlus,
  IconCircleX,
  IconClipboard,
  IconClipboardCheck,
  IconClipboardCopy,
  IconClipboardList,
  IconClock,
  IconClockHour4,
  IconCloud,
  IconCloudDownload,
  IconCloudOff,
  IconCloudUpload,
  IconCode,
  IconCodeDots,
  IconCoin,
  IconColorPicker,
  IconColorSwatch,
  IconColumns,
  IconCommand,
  IconComponents,
  IconCopy,
  IconCornerDownLeft,
  IconCornerDownRight,
  IconCornerUpLeft,
  IconCornerUpRight,
  IconCreditCard,
  IconCrop,
  IconCross,
  IconCrown,
  IconCurrencyDollar,
  IconCurrencyEuro,
  IconCurrencyPound,
  IconCurrencyYen,
  IconCut,
  // D
  IconDashboard,
  IconDatabase,
  IconDeviceDesktop,
  IconDeviceFloppy,
  IconDeviceLaptop,
  IconDeviceMobile,
  IconDeviceTablet,
  IconDeviceTv,
  IconDiamond,
  IconDice,
  IconDisc,
  IconDots,
  IconDotsVertical,
  IconDownload,
  IconDroplet,
  // E
  IconEdit,
  IconEditCircle,
  IconEye,
  IconEyeOff,
  IconExclamationMark,
  IconExternalLink,
  // F
  IconFile,
  IconFileAnalytics,
  IconFileCheck,
  IconFileCode,
  IconFileDescription,
  IconFileDownload,
  IconFileExport,
  IconFileImport,
  IconFileMinus,
  IconFilePlus,
  IconFileSearch,
  IconFileText,
  IconFileUpload,
  IconFileX,
  IconFiles,
  IconFilter,
  IconFilterOff,
  IconFingerprint,
  IconFlag,
  IconFlame,
  IconFlask,
  IconFocus,
  IconFold,
  IconFolder,
  IconFolderMinus,
  IconFolderOff,
  IconFolderPlus,
  IconFolders,
  IconForms,
  IconFrame,
  // G
  IconGauge,
  IconGift,
  IconGitBranch,
  IconGitCommit,
  IconGitFork,
  IconGitMerge,
  IconGitPullRequest,
  IconGlobe,
  IconGraph,
  IconGripHorizontal,
  IconGripVertical,
  // H
  IconH1,
  IconH2,
  IconH3,
  IconH4,
  IconH5,
  IconH6,
  IconHammer,
  IconHandClick,
  IconHandFinger,
  IconHash,
  IconHeadphones,
  IconHeadset,
  IconHeart,
  IconHeartOff,
  IconHelp,
  IconHexagon,
  IconHistory,
  IconHome,
  // IconLightbulb - doesn't exist, use IconBulb
  IconHourglass,
  // I
  IconId,
  IconInbox,
  IconIndentDecrease,
  IconIndentIncrease,
  IconInfoCircle,
  IconItalic,
  // J-K
  IconKey,
  IconKeyboard,
  // L
  IconLanguage,
  // IconLayers - doesn't exist, use IconStack
  IconLayersLinked,
  IconLayout,
  IconLayout2,
  IconLayoutDashboard,
  IconLayoutGrid,
  IconLayoutList,
  IconLayoutSidebar,
  IconLayoutSidebarRight,
  IconLeaf,
  IconLifebuoy,
  IconLine,
  IconLineHeight,
  IconLink,
  IconLinkOff,
  IconList,
  IconListCheck,
  IconListDetails,
  IconListNumbers,
  IconListSearch,
  IconLoader,
  IconLocation,
  IconLock,
  IconLockOff,
  IconLockOpen,
  IconLogin,
  IconLogout,
  // M
  IconMail,
  IconMailOpened,
  IconMap,
  IconMapPin,
  IconMarkdown,
  IconMaximize,
  IconMenu,
  IconMenu2,
  IconMessage,
  IconMessageCircle,
  IconMessageDots,
  IconMicrophone,
  IconMicrophoneOff,
  IconMinimize,
  IconMinus,
  IconMoon,
  IconMoodHappy,
  IconMoodSad,
  IconMouse,
  IconMovie,
  IconMusic,
  // N
  IconNews,
  IconNote,
  IconNotebook,
  IconNotes,
  IconNotification,
  IconNumber,
  // O
  IconOctagon,
  IconOval,
  // P
  IconPackage,
  IconPaint,
  IconPalette,
  IconPaperclip,
  IconPencil,
  IconPentagon,
  IconPercentage,
  IconPhone,
  IconPhoneCall,
  IconPhoneOff,
  IconPhoto,
  IconPhotoOff,
  IconPhotoPlus,
  IconPin,
  IconPinned,
  IconPinnedOff,
  IconPizza,
  IconPlane,
  IconPlanet,
  IconPlayerPause,
  IconPlayerPlay,
  IconPlayerRecord,
  IconPlayerSkipBack,
  IconPlayerSkipForward,
  IconPlayerStop,
  IconPlayerTrackNext,
  IconPlayerTrackPrev,
  IconPlug,
  IconPlugConnected,
  IconPlugOff,
  IconPlus,
  IconPoint,
  IconPolygon,
  IconPower,
  IconPresentation,
  // IconPrint - doesn't exist, use IconPrinter
  IconPrinter,
  IconProgress,
  IconPrompt,
  IconPuzzle,
  // Q-R
  IconQrcode,
  IconQuestionMark,
  IconQuote,
  IconReceipt,
  IconReceiptRefund,
  IconRecordMail,
  IconRectangle,
  IconRefresh,
  IconRefreshAlert,
  IconReload,
  IconRepeat,
  IconReplace,
  IconReport,
  IconReportAnalytics,
  IconResize,
  IconRestore,
  IconRocket,
  IconRotate,
  IconRotate2,
  IconRotateClockwise,
  IconRotateClockwise2,
  IconRoute,
  IconRouter,
  IconRss,
  IconRuler,
  // S
  IconSatellite,
  IconScale,
  IconScan,
  IconSchool,
  IconScreenShare,
  IconScreenShareOff,
  IconScript,
  IconSearch,
  IconSend,
  IconServer,
  IconServerOff,
  IconSettings,
  IconSettingsAutomation,
  IconShape,
  IconShare,
  IconShield,
  IconShieldCheck,
  IconShieldLock,
  IconShieldOff,
  IconShip,
  IconShoppingBag,
  IconShoppingCart,
  IconSignature,
  IconSitemap,
  IconSlash,
  IconSlideshow,
  IconSmartHome,
  IconSocial,
  IconSortAscending,
  IconSortDescending,
  IconSortAscendingLetters,
  IconSortDescendingLetters,
  IconSortAscendingNumbers,
  IconSortDescendingNumbers,
  IconSourceCode,
  IconSparkles,
  IconSpeakerphone,
  IconSquare,
  IconSquareCheck,
  IconSquareMinus,
  IconSquarePlus,
  IconSquareX,
  IconStack,
  IconStack2,
  IconStar,
  IconStarFilled,
  IconStarHalf,
  IconStarOff,
  IconStars,
  IconStethoscope,
  IconSticker,
  IconStrikethrough,
  IconSubscript,
  IconSubtask,
  IconSum,
  IconSun,
  IconSuperscript,
  IconSwitch,
  IconSwitchHorizontal,
  IconSwitchVertical,
  IconSword,
  // T
  IconTable,
  IconTableExport,
  IconTableImport,
  IconTableOff,
  IconTablePlus,
  IconTag,
  IconTags,
  IconTarget,
  IconTemplate,
  IconTerminal,
  IconTerminal2,
  IconTestPipe,
  IconTextCaption,
  IconTextColor,
  IconTextDecrease,
  IconTextIncrease,
  IconTextSize,
  IconThumbDown,
  IconThumbUp,
  IconTicket,
  IconTimeline,
  IconToggleLeft,
  IconToggleRight,
  IconTool,
  IconTools,
  IconTrash,
  IconTrashOff,
  IconTrashX,
  IconTrendingDown,
  IconTrendingUp,
  IconTriangle,
  IconTrophy,
  IconTruck,
  IconTypography,
  // U
  IconUmbrella,
  IconUnderline,
  IconUnlink,
  IconUpload,
  IconUser,
  IconUserCheck,
  IconUserCircle,
  IconUserExclamation,
  IconUserMinus,
  IconUserOff,
  IconUserPlus,
  IconUserSearch,
  IconUserShield,
  IconUserX,
  IconUsers,
  // V
  IconVector,
  IconVersions,
  IconVideo,
  IconVideoOff,
  IconViewfinder,
  IconVocabulary,
  IconVolume,
  IconVolume2,
  IconVolume3,
  IconVolumeOff,
  // W
  IconWallet,
  IconWand,
  IconWifi,
  IconWifiOff,
  IconWindow,
  IconWindowMaximize,
  IconWindowMinimize,
  IconWorld,
  IconWriting,
  // X-Y-Z
  IconX,
  IconZoomIn,
  IconZoomOut,
  IconZoomReset,
  IconZoomCheck,
  IconZoomCancel,
  IconClick,
} from '@tabler/icons-react';
import { ComponentType } from 'react';

export type IconComponent = ComponentType<{
  size?: number | string;
  color?: string;
  stroke?: number;
  className?: string;
}>;

export type IconName =
  // A
  | 'accessible'
  | 'activity'
  | 'adjustments'
  | 'adjustments-horizontal'
  | 'alert'
  | 'alert-circle'
  | 'alert-triangle'
  | 'align-center'
  | 'align-justified'
  | 'align-left'
  | 'alignLeft'
  | 'align-right'
  | 'anchor'
  | 'apps'
  | 'archive'
  | 'arrow-back'
  | 'arrow-back-up'
  | 'arrow-down'
  | 'arrow-forward'
  | 'arrow-forward-up'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'arrows-maximize'
  | 'arrows-minimize'
  | 'arrows-move'
  | 'arrows-sort'
  | 'at'
  | 'atom'
  // B
  | 'ban'
  | 'bell'
  | 'bell-off'
  | 'bold'
  | 'book'
  | 'bookmark'
  | 'bookmark-off'
  | 'box'
  | 'brand-facebook'
  | 'brand-github'
  | 'brand-google'
  | 'brand-instagram'
  | 'brand-linkedin'
  | 'brand-slack'
  | 'brand-twitter'
  | 'brand-youtube'
  | 'briefcase'
  | 'brush'
  | 'bug'
  | 'building'
  | 'building-church'
  | 'bulb'
  // C
  | 'calculator'
  | 'calendar'
  | 'calendar-event'
  | 'calendar-off'
  | 'camera'
  | 'camera-off'
  | 'car'
  | 'cards'
  | 'caret-down'
  | 'caret-left'
  | 'caret-right'
  | 'caret-up'
  | 'cash'
  | 'category'
  | 'chart'
  | 'chart-area'
  | 'chart-bar'
  | 'chart-dots'
  | 'chart-line'
  | 'chart-pie'
  | 'check'
  | 'checkbox'
  | 'checkSquare'
  | 'checklist'
  | 'chevron-down'
  | 'chevronDown'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'chevrons-down'
  | 'chevrons-left'
  | 'chevrons-right'
  | 'chevrons-up'
  | 'circle'
  | 'circle-check'
  | 'circle-dashed'
  | 'circle-dot'
  | 'circle-minus'
  | 'circle-plus'
  | 'circle-x'
  | 'clipboard'
  | 'clipboard-check'
  | 'clipboard-copy'
  | 'clipboard-list'
  | 'click'
  | 'clock'
  | 'clock-hour'
  | 'cloud'
  | 'cloud-download'
  | 'cloud-off'
  | 'cloud-upload'
  | 'code'
  | 'code-dots'
  | 'coin'
  | 'color-picker'
  | 'color-swatch'
  | 'columns'
  | 'command'
  | 'components'
  | 'copy'
  | 'corner-down-left'
  | 'corner-down-right'
  | 'corner-up-left'
  | 'corner-up-right'
  | 'credit-card'
  | 'crop'
  | 'cross'
  | 'crown'
  | 'currency-dollar'
  | 'currency-euro'
  | 'currency-pound'
  | 'currency-yen'
  | 'cut'
  // D
  | 'dashboard'
  | 'database'
  | 'device-desktop'
  | 'device-floppy'
  | 'device-laptop'
  | 'device-mobile'
  | 'device-tablet'
  | 'device-tv'
  | 'diamond'
  | 'dice'
  | 'disc'
  | 'dots-vertical'
  | 'dots-horizontal'
  | 'download'
  | 'droplet'
  // E
  | 'edit'
  | 'edit3'
  | 'edit-circle'
  | 'eye'
  | 'eye-off'
  | 'exclamation'
  | 'external-link'
  // F
  | 'file'
  | 'file-analytics'
  | 'file-check'
  | 'file-code'
  | 'file-description'
  | 'file-download'
  | 'file-export'
  | 'file-import'
  | 'file-minus'
  | 'file-plus'
  | 'file-search'
  | 'file-text'
  | 'fileText'
  | 'file-upload'
  | 'file-x'
  | 'files'
  | 'filter'
  | 'filter-off'
  | 'fingerprint'
  | 'flag'
  | 'flame'
  | 'flask'
  | 'focus'
  | 'fold'
  | 'folder'
  | 'folder-minus'
  | 'folder-off'
  | 'folder-plus'
  | 'folders'
  | 'forms'
  | 'frame'
  // G
  | 'gauge'
  | 'gift'
  | 'git-branch'
  | 'git-commit'
  | 'git-fork'
  | 'git-merge'
  | 'git-pull-request'
  | 'globe'
  | 'graph'
  | 'grip-horizontal'
  | 'grip-vertical'
  | 'gripVertical'
  // H
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'hammer'
  | 'hand-click'
  | 'hand-finger'
  | 'hash'
  | 'headphones'
  | 'headset'
  | 'heading'
  | 'heart'
  | 'heart-off'
  | 'help'
  | 'hexagon'
  | 'history'
  | 'home'
  | 'hourglass'
  // I
  | 'id'
  | 'image'
  | 'inbox'
  | 'indent-decrease'
  | 'indent-increase'
  | 'info'
  | 'info-circle'
  | 'italic'
  // J-K
  | 'key'
  | 'keyboard'
  // L
  | 'language'
  | 'layers'
  | 'layers-linked'
  | 'layout'
  | 'layout-2'
  | 'layout-dashboard'
  | 'layout-grid'
  | 'layoutGrid'
  | 'layout-list'
  | 'layout-sidebar'
  | 'layout-sidebar-right'
  | 'leaf'
  | 'lifebuoy'
  | 'lightbulb'
  | 'line'
  | 'line-height'
  | 'link'
  | 'link-off'
  | 'list'
  | 'list-check'
  | 'listChecks'
  | 'list-details'
  | 'list-numbers'
  | 'list-search'
  | 'loader'
  | 'location'
  | 'lock'
  | 'lock-off'
  | 'lock-open'
  | 'login'
  | 'logout'
  // M
  | 'mail'
  | 'mail-opened'
  | 'map'
  | 'map-pin'
  | 'markdown'
  | 'maximize'
  | 'menu'
  | 'menu-2'
  | 'message'
  | 'message-circle'
  | 'message-dots'
  | 'microphone'
  | 'microphone-off'
  | 'minimize'
  | 'minus'
  | 'moon'
  | 'mood-happy'
  | 'mood-sad'
  | 'mouse'
  | 'moveVertical'
  | 'movie'
  | 'music'
  // N
  | 'news'
  | 'note'
  | 'notebook'
  | 'notes'
  | 'notification'
  | 'number'
  // O
  | 'octagon'
  | 'oval'
  // P
  | 'package'
  | 'paint'
  | 'palette'
  | 'paperclip'
  | 'pencil'
  | 'pentagon'
  | 'percentage'
  | 'phone'
  | 'phone-call'
  | 'phone-off'
  | 'photo'
  | 'photo-off'
  | 'photo-plus'
  | 'pin'
  | 'pinned'
  | 'pinned-off'
  | 'pizza'
  | 'plane'
  | 'planet'
  | 'pause'
  | 'play'
  | 'player-pause'
  | 'player-play'
  | 'player-record'
  | 'player-skip-back'
  | 'player-skip-forward'
  | 'player-stop'
  | 'player-track-next'
  | 'player-track-prev'
  | 'plug'
  | 'plug-connected'
  | 'plug-off'
  | 'plus'
  | 'point'
  | 'polygon'
  | 'power'
  | 'presentation'
  | 'print'
  | 'printer'
  | 'progress'
  | 'prompt'
  | 'puzzle'
  // Q-R
  | 'qrcode'
  | 'question'
  | 'question-mark'
  | 'quote'
  | 'receipt'
  | 'receipt-refund'
  | 'record-mail'
  | 'rectangle'
  | 'refresh'
  | 'refresh-alert'
  | 'reload'
  | 'repeat'
  | 'replace'
  | 'report'
  | 'report-analytics'
  | 'resize'
  | 'restore'
  | 'rocket'
  | 'rotate'
  | 'rotate-2'
  | 'rotate-clockwise'
  | 'rotate-clockwise-2'
  | 'route'
  | 'router'
  | 'rss'
  | 'ruler'
  // S
  | 'satellite'
  | 'scale'
  | 'scan'
  | 'school'
  | 'screen-share'
  | 'screen-share-off'
  | 'script'
  | 'search'
  | 'send'
  | 'server'
  | 'server-off'
  | 'settings'
  | 'settings-automation'
  | 'shape'
  | 'share'
  | 'shield'
  | 'shield-check'
  | 'shield-lock'
  | 'shield-off'
  | 'ship'
  | 'shopping-bag'
  | 'shopping-cart'
  | 'signature'
  | 'sitemap'
  | 'slash'
  | 'sliders'
  | 'slideshow'
  | 'smart-home'
  | 'social'
  | 'sort-ascending'
  | 'sort-descending'
  | 'sort-ascending-letters'
  | 'sort-descending-letters'
  | 'sort-ascending-numbers'
  | 'sort-descending-numbers'
  | 'source-code'
  | 'sparkles'
  | 'speakerphone'
  | 'square'
  | 'square-check'
  | 'square-minus'
  | 'square-plus'
  | 'square-x'
  | 'stack'
  | 'stack-2'
  | 'star'
  | 'star-filled'
  | 'star-half'
  | 'star-off'
  | 'stars'
  | 'stethoscope'
  | 'sticker'
  | 'stop'
  | 'strikethrough'
  | 'subscript'
  | 'subtask'
  | 'sum'
  | 'sun'
  | 'superscript'
  | 'switch'
  | 'switch-horizontal'
  | 'switch-vertical'
  | 'sword'
  // T
  | 'table'
  | 'table-export'
  | 'table-import'
  | 'table-off'
  | 'table-plus'
  | 'tag'
  | 'tags'
  | 'target'
  | 'template'
  | 'terminal'
  | 'terminal-2'
  | 'test-pipe'
  | 'text'
  | 'text-caption'
  | 'text-color'
  | 'text-decrease'
  | 'text-increase'
  | 'text-size'
  | 'thumb-down'
  | 'thumb-up'
  | 'ticket'
  | 'timeline'
  | 'toggle-left'
  | 'toggle-right'
  | 'toggleRight'
  | 'tool'
  | 'tools'
  | 'trash'
  | 'trash-off'
  | 'trash-x'
  | 'trending-down'
  | 'trending-up'
  | 'triangle'
  | 'trophy'
  | 'truck'
  | 'type'
  | 'typography'
  // U
  | 'umbrella'
  | 'underline'
  | 'unlink'
  | 'upload'
  | 'user'
  | 'user-check'
  | 'user-circle'
  | 'user-exclamation'
  | 'user-minus'
  | 'user-off'
  | 'user-plus'
  | 'user-search'
  | 'user-shield'
  | 'user-x'
  | 'users'
  // V
  | 'vector'
  | 'versions'
  | 'video'
  | 'video-off'
  | 'viewfinder'
  | 'vocabulary'
  | 'volume'
  | 'volume-2'
  | 'volume-3'
  | 'volume-off'
  // W
  | 'wallet'
  | 'wand'
  | 'wifi'
  | 'wifi-off'
  | 'window'
  | 'window-maximize'
  | 'window-minimize'
  | 'world'
  | 'writing'
  // X-Y-Z
  | 'x'
  | 'zoom-in'
  | 'zoom-out'
  | 'zoom-reset'
  | 'zoom-check'
  | 'zoom-cancel';

export type IconRegistry = Record<string, IconComponent>;

export const ICON_MAP: IconRegistry = {
  // A
  accessible: IconAccessible,
  activity: IconActivity,
  adjustments: IconAdjustments,
  'adjustments-horizontal': IconAdjustmentsHorizontal,
  alert: IconAlertCircle,
  'alert-circle': IconAlertCircle,
  'alert-triangle': IconAlertTriangle,
  'align-center': IconAlignCenter,
  'align-justified': IconAlignJustified,
  'align-left': IconAlignLeft,
  alignLeft: IconAlignLeft,
  'align-right': IconAlignRight,
  anchor: IconAnchor,
  apps: IconApps,
  archive: IconArchive,
  'arrow-back': IconArrowBack,
  'arrow-back-up': IconArrowBackUp,
  undo: IconArrowBackUp,
  'arrow-down': IconArrowDown,
  'arrow-forward': IconArrowForward,
  'arrow-forward-up': IconArrowForwardUp,
  redo: IconArrowForwardUp,
  'arrow-left': IconArrowLeft,
  'arrow-right': IconArrowRight,
  'arrow-up': IconArrowUp,
  'arrows-maximize': IconArrowsMaximize,
  'arrows-minimize': IconArrowsMinimize,
  'arrows-move': IconArrowsMove,
  'arrows-sort': IconArrowsSort,
  at: IconAt,
  atom: IconAtom,

  // B
  ban: IconBan,
  bell: IconBell,
  'bell-off': IconBellOff,
  bold: IconBold,
  book: IconBook,
  bookmark: IconBookmark,
  'bookmark-off': IconBookmarkOff,
  box: IconBox,
  'brand-facebook': IconBrandFacebook,
  'brand-github': IconBrandGithub,
  'brand-google': IconBrandGoogle,
  'brand-instagram': IconBrandInstagram,
  'brand-linkedin': IconBrandLinkedin,
  'brand-slack': IconBrandSlack,
  'brand-twitter': IconBrandTwitter,
  'brand-youtube': IconBrandYoutube,
  briefcase: IconBriefcase,
  brush: IconBrush,
  bug: IconBug,
  building: IconBuilding,
  'building-church': IconBuildingChurch,
  bulb: IconBulb,

  // C
  calculator: IconCalculator,
  calendar: IconCalendar,
  'calendar-event': IconCalendarEvent,
  'calendar-off': IconCalendarOff,
  camera: IconCamera,
  'camera-off': IconCameraOff,
  car: IconCar,
  cards: IconCards,
  'caret-down': IconCaretDown,
  'caret-left': IconCaretLeft,
  'caret-right': IconCaretRight,
  'caret-up': IconCaretUp,
  cash: IconCash,
  category: IconCategory,
  chart: IconChartBar,
  'chart-area': IconChartArea,
  'chart-bar': IconChartBar,
  'chart-dots': IconChartDots,
  'chart-line': IconChartLine,
  'chart-pie': IconChartPie,
  check: IconCheck,
  checkbox: IconCheckbox,
  checkSquare: IconSquareCheck,
  checklist: IconChecklist,
  'chevron-down': IconChevronDown,
  chevronDown: IconChevronDown,
  'chevron-left': IconChevronLeft,
  'chevron-right': IconChevronRight,
  'chevron-up': IconChevronUp,
  'chevrons-down': IconChevronsDown,
  'chevrons-left': IconChevronsLeft,
  'chevrons-right': IconChevronsRight,
  'chevrons-up': IconChevronsUp,
  circle: IconCircle,
  'circle-check': IconCircleCheck,
  checkCircle: IconCircleCheck,
  'circle-dashed': IconCircleDashed,
  'circle-dot': IconCircleDot,
  'circle-minus': IconCircleMinus,
  'circle-plus': IconCirclePlus,
  'circle-x': IconCircleX,
  clipboard: IconClipboard,
  'clipboard-check': IconClipboardCheck,
  'clipboard-copy': IconClipboardCopy,
  'clipboard-list': IconClipboardList,
  click: IconClick,
  clock: IconClock,
  'clock-hour': IconClockHour4,
  cloud: IconCloud,
  'cloud-download': IconCloudDownload,
  'cloud-off': IconCloudOff,
  'cloud-upload': IconCloudUpload,
  code: IconCode,
  'code-dots': IconCodeDots,
  coin: IconCoin,
  'color-picker': IconColorPicker,
  'color-swatch': IconColorSwatch,
  columns: IconColumns,
  command: IconCommand,
  components: IconComponents,
  copy: IconCopy,
  'corner-down-left': IconCornerDownLeft,
  'corner-down-right': IconCornerDownRight,
  'corner-up-left': IconCornerUpLeft,
  'corner-up-right': IconCornerUpRight,
  'credit-card': IconCreditCard,
  crop: IconCrop,
  cross: IconCross,
  crown: IconCrown,
  'currency-dollar': IconCurrencyDollar,
  'currency-euro': IconCurrencyEuro,
  'currency-pound': IconCurrencyPound,
  'currency-yen': IconCurrencyYen,
  cut: IconCut,

  // D
  dashboard: IconDashboard,
  database: IconDatabase,
  'device-desktop': IconDeviceDesktop,
  'device-floppy': IconDeviceFloppy,
  'device-laptop': IconDeviceLaptop,
  'device-mobile': IconDeviceMobile,
  'device-tablet': IconDeviceTablet,
  'device-tv': IconDeviceTv,
  monitor: IconDeviceDesktop,
  tablet: IconDeviceTablet,
  smartphone: IconDeviceMobile,
  diamond: IconDiamond,
  dice: IconDice,
  disc: IconDisc,
  'dots-vertical': IconDotsVertical,
  'dots-horizontal': IconDots,
  moreHorizontal: IconDots,
  moreVertical: IconDotsVertical,
  download: IconDownload,
  droplet: IconDroplet,

  // E
  edit: IconEdit,
  edit3: IconEdit,
  'edit-circle': IconEditCircle,
  eye: IconEye,
  'eye-off': IconEyeOff,
  exclamation: IconExclamationMark,
  'external-link': IconExternalLink,

  // F
  file: IconFile,
  'file-analytics': IconFileAnalytics,
  'file-check': IconFileCheck,
  'file-code': IconFileCode,
  'file-description': IconFileDescription,
  'file-download': IconFileDownload,
  'file-export': IconFileExport,
  'file-import': IconFileImport,
  'file-minus': IconFileMinus,
  'file-plus': IconFilePlus,
  'file-search': IconFileSearch,
  'file-text': IconFileText,
  fileText: IconFileText,
  'file-upload': IconFileUpload,
  'file-x': IconFileX,
  files: IconFiles,
  filter: IconFilter,
  'filter-off': IconFilterOff,
  fingerprint: IconFingerprint,
  flag: IconFlag,
  flame: IconFlame,
  flask: IconFlask,
  focus: IconFocus,
  fold: IconFold,
  folder: IconFolder,
  'folder-minus': IconFolderMinus,
  'folder-off': IconFolderOff,
  'folder-plus': IconFolderPlus,
  folders: IconFolders,
  forms: IconForms,
  frame: IconFrame,

  // G
  gauge: IconGauge,
  gift: IconGift,
  'git-branch': IconGitBranch,
  gitBranch: IconGitBranch,
  'git-commit': IconGitCommit,
  'git-fork': IconGitFork,
  'git-merge': IconGitMerge,
  'git-pull-request': IconGitPullRequest,
  globe: IconGlobe,
  graph: IconGraph,
  'grip-horizontal': IconGripHorizontal,
  'grip-vertical': IconGripVertical,
  gripVertical: IconGripVertical,

  // H
  h1: IconH1,
  h2: IconH2,
  h3: IconH3,
  h4: IconH4,
  h5: IconH5,
  h6: IconH6,
  hammer: IconHammer,
  'hand-click': IconHandClick,
  'hand-finger': IconHandFinger,
  hash: IconHash,
  headphones: IconHeadphones,
  headset: IconHeadset,
  heading: IconH1,
  heart: IconHeart,
  'heart-off': IconHeartOff,
  help: IconHelp,
  hexagon: IconHexagon,
  history: IconHistory,
  home: IconHome,
  hourglass: IconHourglass,

  // I
  id: IconId,
  image: IconPhoto,
  inbox: IconInbox,
  'indent-decrease': IconIndentDecrease,
  'indent-increase': IconIndentIncrease,
  info: IconInfoCircle,
  'info-circle': IconInfoCircle,
  italic: IconItalic,

  // J-K
  key: IconKey,
  keyboard: IconKeyboard,

  // L
  language: IconLanguage,
  layers: IconStack,
  'layers-linked': IconLayersLinked,
  layout: IconLayout,
  'layout-2': IconLayout2,
  'layout-dashboard': IconLayoutDashboard,
  'layout-grid': IconLayoutGrid,
  layoutGrid: IconLayoutGrid,
  'layout-list': IconLayoutList,
  layoutList: IconLayoutList,
  'layout-sidebar': IconLayoutSidebar,
  'layout-sidebar-right': IconLayoutSidebarRight,
  leaf: IconLeaf,
  lifebuoy: IconLifebuoy,
  lightbulb: IconBulb,
  link: IconLink,
  'link-off': IconLinkOff,
  list: IconList,
  'list-check': IconListCheck,
  listChecks: IconListCheck,
  'list-details': IconListDetails,
  'list-numbers': IconListNumbers,
  'list-search': IconListSearch,
  loader: IconLoader,
  location: IconLocation,
  lock: IconLock,
  'lock-off': IconLockOff,
  'lock-open': IconLockOpen,
  login: IconLogin,
  logout: IconLogout,

  // M
  mail: IconMail,
  'mail-opened': IconMailOpened,
  map: IconMap,
  'map-pin': IconMapPin,
  markdown: IconMarkdown,
  maximize: IconMaximize,
  menu: IconMenu,
  'menu-2': IconMenu2,
  message: IconMessage,
  'message-circle': IconMessageCircle,
  'message-dots': IconMessageDots,
  microphone: IconMicrophone,
  'microphone-off': IconMicrophoneOff,
  minimize: IconMinimize,
  minus: IconMinus,
  moon: IconMoon,
  'mood-happy': IconMoodHappy,
  'mood-sad': IconMoodSad,
  mouse: IconMouse,
  moveVertical: IconArrowsSort,
  movie: IconMovie,
  music: IconMusic,

  // N
  news: IconNews,
  note: IconNote,
  notebook: IconNotebook,
  notes: IconNotes,
  notification: IconNotification,
  number: IconNumber,

  // O
  octagon: IconOctagon,
  oval: IconOval,

  // P
  package: IconPackage,
  paint: IconPaint,
  palette: IconPalette,
  paperclip: IconPaperclip,
  pencil: IconPencil,
  pentagon: IconPentagon,
  percentage: IconPercentage,
  phone: IconPhone,
  'phone-call': IconPhoneCall,
  'phone-off': IconPhoneOff,
  photo: IconPhoto,
  'photo-off': IconPhotoOff,
  'photo-plus': IconPhotoPlus,
  pin: IconPin,
  pinned: IconPinned,
  'pinned-off': IconPinnedOff,
  pizza: IconPizza,
  plane: IconPlane,
  planet: IconPlanet,
  pause: IconPlayerPause,
  play: IconPlayerPlay,
  'player-pause': IconPlayerPause,
  'player-play': IconPlayerPlay,
  'player-record': IconPlayerRecord,
  'player-skip-back': IconPlayerSkipBack,
  'player-skip-forward': IconPlayerSkipForward,
  'player-stop': IconPlayerStop,
  'player-track-next': IconPlayerTrackNext,
  'player-track-prev': IconPlayerTrackPrev,
  plug: IconPlug,
  'plug-connected': IconPlugConnected,
  'plug-off': IconPlugOff,
  plus: IconPlus,
  point: IconPoint,
  polygon: IconPolygon,
  power: IconPower,
  presentation: IconPresentation,
  print: IconPrinter,
  printer: IconPrinter,
  progress: IconProgress,
  prompt: IconPrompt,
  puzzle: IconPuzzle,

  // Q-R
  qrcode: IconQrcode,
  question: IconQuestionMark,
  'question-mark': IconQuestionMark,
  quote: IconQuote,
  receipt: IconReceipt,
  'receipt-refund': IconReceiptRefund,
  'record-mail': IconRecordMail,
  rectangle: IconRectangle,
  refresh: IconRefresh,
  'refresh-alert': IconRefreshAlert,
  reload: IconReload,
  repeat: IconRepeat,
  replace: IconReplace,
  report: IconReport,
  'report-analytics': IconReportAnalytics,
  resize: IconResize,
  restore: IconRestore,
  rocket: IconRocket,
  rotate: IconRotate,
  'rotate-2': IconRotate2,
  'rotate-clockwise': IconRotateClockwise,
  'rotate-clockwise-2': IconRotateClockwise2,
  route: IconRoute,
  router: IconRouter,
  rss: IconRss,
  ruler: IconRuler,

  // S
  save: IconDeviceFloppy,
  satellite: IconSatellite,
  scale: IconScale,
  scan: IconScan,
  school: IconSchool,
  'screen-share': IconScreenShare,
  'screen-share-off': IconScreenShareOff,
  script: IconScript,
  search: IconSearch,
  send: IconSend,
  server: IconServer,
  'server-off': IconServerOff,
  settings: IconSettings,
  'settings-automation': IconSettingsAutomation,
  shape: IconShape,
  share: IconShare,
  shield: IconShield,
  'shield-check': IconShieldCheck,
  'shield-lock': IconShieldLock,
  'shield-off': IconShieldOff,
  ship: IconShip,
  'shopping-bag': IconShoppingBag,
  'shopping-cart': IconShoppingCart,
  signature: IconSignature,
  sitemap: IconSitemap,
  slash: IconSlash,
  sliders: IconAdjustments,
  slideshow: IconSlideshow,
  'smart-home': IconSmartHome,
  social: IconSocial,
  'sort-ascending': IconSortAscending,
  'sort-descending': IconSortDescending,
  'sort-ascending-letters': IconSortAscendingLetters,
  'sort-descending-letters': IconSortDescendingLetters,
  'sort-ascending-numbers': IconSortAscendingNumbers,
  'sort-descending-numbers': IconSortDescendingNumbers,
  'source-code': IconSourceCode,
  sparkles: IconSparkles,
  speakerphone: IconSpeakerphone,
  square: IconSquare,
  'square-check': IconSquareCheck,
  'square-minus': IconSquareMinus,
  'square-plus': IconSquarePlus,
  'square-x': IconSquareX,
  stack: IconStack,
  'stack-2': IconStack2,
  star: IconStar,
  'star-filled': IconStarFilled,
  'star-half': IconStarHalf,
  'star-off': IconStarOff,
  stars: IconStars,
  stethoscope: IconStethoscope,
  sticker: IconSticker,
  stop: IconPlayerStop,
  strikethrough: IconStrikethrough,
  subscript: IconSubscript,
  subtask: IconSubtask,
  sum: IconSum,
  sun: IconSun,
  superscript: IconSuperscript,
  switch: IconSwitch,
  'switch-horizontal': IconSwitchHorizontal,
  'switch-vertical': IconSwitchVertical,
  sword: IconSword,

  // T
  table: IconTable,
  'table-export': IconTableExport,
  'table-import': IconTableImport,
  'table-off': IconTableOff,
  'table-plus': IconTablePlus,
  tag: IconTag,
  tags: IconTags,
  target: IconTarget,
  template: IconTemplate,
  terminal: IconTerminal,
  'terminal-2': IconTerminal2,
  'test-pipe': IconTestPipe,
  text: IconTypography,
  'text-caption': IconTextCaption,
  'text-color': IconTextColor,
  'text-decrease': IconTextDecrease,
  'text-increase': IconTextIncrease,
  'text-size': IconTextSize,
  'thumb-down': IconThumbDown,
  'thumb-up': IconThumbUp,
  ticket: IconTicket,
  timeline: IconTimeline,
  'toggle-left': IconToggleLeft,
  'toggle-right': IconToggleRight,
  toggleRight: IconToggleRight,
  tool: IconTool,
  tools: IconTools,
  trash: IconTrash,
  'trash-off': IconTrashOff,
  'trash-x': IconTrashX,
  'trending-down': IconTrendingDown,
  'trending-up': IconTrendingUp,
  triangle: IconTriangle,
  trophy: IconTrophy,
  truck: IconTruck,
  type: IconTypography,
  typography: IconTypography,

  // U
  umbrella: IconUmbrella,
  underline: IconUnderline,
  unlink: IconUnlink,
  upload: IconUpload,
  user: IconUser,
  'user-check': IconUserCheck,
  'user-circle': IconUserCircle,
  'user-exclamation': IconUserExclamation,
  'user-minus': IconUserMinus,
  'user-off': IconUserOff,
  'user-plus': IconUserPlus,
  'user-search': IconUserSearch,
  'user-shield': IconUserShield,
  'user-x': IconUserX,
  users: IconUsers,

  // V
  vector: IconVector,
  versions: IconVersions,
  video: IconVideo,
  'video-off': IconVideoOff,
  viewfinder: IconViewfinder,
  vocabulary: IconVocabulary,
  volume: IconVolume,
  'volume-2': IconVolume2,
  'volume-3': IconVolume3,
  'volume-off': IconVolumeOff,

  // W
  wallet: IconWallet,
  wand: IconWand,
  wifi: IconWifi,
  'wifi-off': IconWifiOff,
  window: IconWindow,
  'window-maximize': IconWindowMaximize,
  'window-minimize': IconWindowMinimize,
  world: IconWorld,
  writing: IconWriting,

  // X-Y-Z
  x: IconX,
  'zoom-in': IconZoomIn,
  'zoom-out': IconZoomOut,
  'zoom-reset': IconZoomReset,
  'zoom-check': IconZoomCheck,
  'zoom-cancel': IconZoomCancel,
};

/**
 * Get an icon component by name
 * Returns IconSquare as fallback if icon not found
 */
export function getIconByName(name?: string, registry: IconRegistry = ICON_MAP): IconComponent {
  if (!name) return IconSquare;
  return registry[name] || IconSquare;
}

/**
 * Check if an icon name exists in the registry
 */
export function hasIcon(name: string, registry: IconRegistry = ICON_MAP): boolean {
  return name in registry;
}

/**
 * Get all available icon names
 */
export function getIconNames(registry: IconRegistry = ICON_MAP): string[] {
  return Object.keys(registry);
}
